import React, { ButtonHTMLAttributes } from 'react'
import { z } from 'zod'

import { LinkSizeKeys, LinkUseKeys } from '@/components/ui/link'

export const ButtonUseEnum = z.enum([
  'primary',
  'primary-light',
  'secondary',
  'ghost',
  'ghost-light',
  'ghost-error',
  'inverted',
  'ai',
  'upsell',
  'upsell-secondary',
  'danger',
  'warning',
  'success',
  'unset',
])

export type ButtonUseKeys = z.infer<typeof ButtonUseEnum>

export const ButtonSizeEnum = z.enum(['large', 'medium', 'small', 'unset'])

export type ButtonSizeKeys = z.infer<typeof ButtonSizeEnum>

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  use?: LinkUseKeys
  size?: LinkSizeKeys
  loading?: boolean
  onlyBox?: boolean
  onlyCircle?: boolean
  compact?: boolean
  disabled?: boolean
  active?: boolean
}
